import React, { createContext, useContext, ReactNode } from "react";

/**
 * Modelo agregado do formulário de edição (descrição + características).
 * Montado em `index.tsx` com o mesmo estado/handlers que existiam no componente monolítico.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type EditPropertyWizardModel = Record<string, any>;

const EditPropertyWizardContext = createContext<EditPropertyWizardModel | null>(
  null
);

export function EditPropertyWizardProvider({
  value,
  children,
}: {
  value: EditPropertyWizardModel;
  children: ReactNode;
}) {
  return (
    <EditPropertyWizardContext.Provider value={value}>
      {children}
    </EditPropertyWizardContext.Provider>
  );
}

export function useEditPropertyWizard(): EditPropertyWizardModel {
  const ctx = useContext(EditPropertyWizardContext);
  if (!ctx) {
    throw new Error(
      "useEditPropertyWizard deve ser usado dentro de EditPropertyWizardProvider"
    );
  }
  return ctx;
}
